import cinemaPass from "../assets/images/prizes/costa-cinema-prize.png";
import shoppingVoucher from "../assets/images/prizes/costa-shopping-voucher.png";
import fuelVoucher from "../assets/images/prizes/costa-fuel-voucher.png";
import diningExperience from "../assets/images/prizes/costa-dining-experience.png";
import holidayOrCash from "../assets/images/prizes/costa-holiday.png";

export const prizes = [
  {
    name: "Costa Coffee",
    description:
      "A free coffee on us, which you can claim in our retail stores with your £5 Costa gift card.",
  },
  {
    name: "Costa coffee & baked good",
    description:
      "A free coffee and cake on us, which you can claim in our retail stores with your £10 Costa gift card. ",
  },
  {
    name: "Costa coffee merchandise",
    description:
      "A £15 gift card to use in Costa Coffee shop outlets on anything you want – pick up a travel cup or mug so you can enjoy Costa wherever you are.",
  },
  {
    name: "Shopping vouchers",
    description:
      "You can win £20 Amazon or £10 Love2Shop vouchers daily to spend on a much needed treat.",
    image: shoppingVoucher,
  },
  {
    name: "Cinema tickets",
    description: "A £20 gift card to redeem on a cinema date for two tickets to a movie of your choice (or one) at Odeon cinemas.",
    image: cinemaPass,
  },
 
  {
    name: "Fuel voucher",
    description: "You can win £40 off your next fuel top up at Shell garages.",
    image: fuelVoucher,
  },
  {
    name: "Holiday or Cash",
    image: holidayOrCash,
    id: "holiday-or-cash",
  },
  {
    name: "Holiday to Barcelona for 2",
    description:
      "An all expenses paid trip to Barcelona for 2 adults. One lucky winner will be able to whisk their loved one away for 5 nights at a 4 star bed and breakfast in the cultural, Spanish city.",
  },
  {
    name: "Cash prize",
    description:
      "We’re also giving away one cash prize to the value of £2,000!",
  },
];
